import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import SelectAllChecksGroup from "../../../../../reusable/Form/SelectAllChecksGroup";
import PestleShape from './../DashboardFilters.jsx';

class PESTLEFilter extends Component {

    static propTypes = {
        pestle: PropTypes.shape(PestleShape),
        switchPestle: PropTypes.func
    }

    static defaultProps = {
        pestle: {
            political: true,
            economic: true,
            social: true,
            technological: true,
            legal: true,
            environmental: true
        }
    }

    constructor(props) {
        super(props);

        this.filterByPestle = this.filterByPestle.bind(this)
    }

    filterByPestle(options) {
        let newPestle = Object.assign({}, this.props.pestle);

        for (let i in options) {
            newPestle[options[i].name] = options[i].value
        }

        this.props.switchPestle(newPestle);
    };

    render() {
        const options = [
            {
                name: "political",
                value: this.props.pestle.political,
                label: this.props.intl.formatMessage({ id: 'General_CoreFunctionality_UIText_general.political' })
            },
            {
                name: "economic",
                value: this.props.pestle.economic,
                label: this.props.intl.formatMessage({ id: 'General_CoreFunctionality_UIText_general.economic' })
            },
            {
                name: "social",
                value: this.props.pestle.social,
                label: this.props.intl.formatMessage({ id: 'General_CoreFunctionality_UIText_general.social' })
            },
            {
                name: "technological",
                value: this.props.pestle.technological,
                label: this.props.intl.formatMessage({ id: 'General_CoreFunctionality_UIText_general.technological' })
            },
            {
                name: "legal",
                value: this.props.pestle.legal,
                label: this.props.intl.formatMessage({ id: 'General_CoreFunctionality_UIText_general.legal' })
            },
            {
                name: "environmental",
                value: this.props.pestle.environmental,
                label: this.props.intl.formatMessage({ id: 'General_CoreFunctionality_UIText_general.environmental' })
            }
        ]

        return <SelectAllChecksGroup onChange={this.filterByPestle}
                            options={options}
                            selectAll={this.props.intl.formatMessage({ id: "Dashboard_CoreFunctionality_UIText_dashboard.selectAll" })}
                            classNames="risk-angles-filter notranslate"/>
    }

}

export default injectIntl(PESTLEFilter);


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/FilterPod/PESTLE.filter.jsx